/* Opt-in hand-off to the existing native Zepto editor. No product values are written. */
(function () {
  'use strict';
  if (new URLSearchParams(window.location.search).get('sm_personalize') !== '1') return;
  if (window.__smrwPersonalizeEntryStarted) return;
  window.__smrwPersonalizeEntryStarted = true;

  function start() {
    var root = document.getElementById('product-top');
    if (!root) return;
    var state = 'waiting', completed = false, clicked = false;
    var timer = null, poll = null, scheduled = false;
    var labelledFields = new WeakSet();
    var fieldSelector = '.pplr-wrapper input.pplr_text, .pplr-wrapper textarea, .pplr-wrapper select.pplr_select, .pplr-wrapper input.pplr_imgg';
    var textSelector = '.pplr-wrapper input.pplr_text, .pplr-wrapper textarea';
    var popupSelector = '.pplr_crop-modal, .pplr-modal-box, #pplr-preview';
    var editorSelector = '.pplr-modal-box .pplr_atc_form';
    var status = document.createElement('div');
    status.className = 'smrw-personalize-entry';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.style.cssText = 'margin:0 0 14px;padding:12px 14px;border:1px solid #d9e2ef;border-radius:6px;background:#f2f5fa;color:#202020;font:400 13px/1.6 Poppins,sans-serif;';
    var message = document.createElement('p');
    message.style.margin = '0';
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.textContent = 'Réessayer';
    retry.hidden = true;
    retry.style.cssText = 'min-height:44px;margin-top:8px;padding:8px 14px;border:1px solid #0044cc;border-radius:5px;background:#0044cc;color:white;font:500 13px Poppins,sans-serif;cursor:pointer;';
    status.append(message, retry);
    var host = root.querySelector('.product__info') || root;
    host.insertBefore(status, host.firstChild);

    function visible(element) {
      if (!element || !element.getClientRects().length || element.closest('[hidden], [aria-hidden="true"]')) return false;
      for (var current = element; current; current = current.parentElement) {
        if (current.hidden || (current.getAttribute && current.getAttribute('aria-hidden') === 'true')) return false;
        var style = window.getComputedStyle(current);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') return false;
      }
      return true;
    }
    function guardSubmit(event) {
      if (completed) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    function guardClick(event) {
      if (completed || !event.target.closest) return;
      var original = event.target.closest('.product-form__submit');
      if (!original || original.matches('.pplr-c-button')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    function fieldId(field) {
      if (field.id) return field.id;
      var name = field.getAttribute('name') || '', hash = 2166136261;
      for (var i = 0; i < name.length; i++) hash = Math.imul(hash ^ name.charCodeAt(i), 16777619);
      var base = 'smrw-native-field-' + (hash >>> 0).toString(36), id = base, count = 1;
      while (document.getElementById(id) && document.getElementById(id) !== field) id = base + '-' + (++count);
      field.id = id;
      return id;
    }
    function displayLabel(property) {
      // Display only: these verified production aliases must retain their original form names.
      var text = property.replace(/\s+/g, ' ').trim();
      var product = (window.location.pathname || '').match(/\/products\/([^/]+)/);
      if (product && product[1] === 'plaque-anneaux-coeur-decoration-personnalisee') {
        if (text === 'Name - oben') return 'Prénom de gauche';
        if (text === 'Name - unten') return 'Prénom de droite';
      }
      if (text === 'Date' && product &&
          (product[1] === 'monogramme-personnalise-decoration-murale' || product[1] === 'yin-und-yang-roses')) {
        return 'Texte du bas';
      }
      switch (text) {
        case 'Name - oben': return 'Prénom du haut';
        case 'Name - unten': return 'Prénom du bas';
        case 'Wunschtext': return 'Texte souhaité';
        case 'Wunschtext - Oben': return 'Texte souhaité en haut';
        case 'Wunschtext - Mitte': return 'Texte souhaité au milieu';
        case 'Wunschtext - Unten':
        case 'Wunschtext - unten': return 'Texte souhaité en bas';
        case 'Mitte': return 'Chiffre au milieu';
        case 'Datum unten': return 'Chiffres en bas';
        default: return text;
      }
    }
    function labelNativeFields() {
      document.querySelectorAll(textSelector).forEach(function (field) {
        // Both safeguards survive native form cloning: the WeakSet covers this node;
        // the attribute is copied with a clone, so duplicate IDs never cause relabelling loops.
        if (labelledFields.has(field) || field.hasAttribute('data-smrw-native-label-processed')) return;
        if (!visible(field) || field.type === 'hidden') return;
        var popup = field.closest(popupSelector);
        var inline = field.closest('.product-personalizer, #pplr_html');
        if (popup ? !visible(popup) : !inline || !root.contains(inline) || !visible(inline)) return;
        var property = (field.getAttribute('name') || '').match(/^properties\[([^\]]+)\]$/);
        if (!property || property[1].charAt(0) === '_') return;
        var wrapper = field.closest('.pplr-wrapper');
        if (!wrapper || !field.parentNode) return;
        if (wrapper.querySelector('[data-smrw-native-label]')) {
          labelledFields.add(field);
          field.setAttribute('data-smrw-native-label-processed', '1');
          return;
        }
        var hasLabel = Array.from(field.labels || []).some(function (label) { return visible(label) && label.textContent.trim(); });
        // Mark before changing IDs or inserting labels; observers may run again after either mutation.
        labelledFields.add(field);
        field.setAttribute('data-smrw-native-label-processed', '1');
        if (hasLabel) return;
        var label = document.createElement('label');
        label.className = 'smrw-native-field-label';
        label.setAttribute('data-smrw-native-label', '');
        label.htmlFor = fieldId(field);
        label.textContent = displayLabel(property[1]);
        label.style.cssText = 'width:100%;margin:0 0 5px;padding:0;color:#202020;font:500 12px/1.5 Poppins,sans-serif;';
        label.style.setProperty('display', 'block', 'important');
        field.parentNode.insertBefore(label, field);
      });
    }
    function stopWaiting() {
      clearTimeout(timer);
      clearInterval(poll);
      if (waitingObserver) waitingObserver.disconnect();
    }
    function finish() {
      if (completed) return;
      completed = true;
      state = 'ready';
      stopWaiting();
      root.removeEventListener('submit', guardSubmit, true);
      root.removeEventListener('click', guardClick, true);
      status.remove();
      labelNativeFields();
    }
    function check() {
      if (completed || (state !== 'waiting' && state !== 'opening')) return;
      labelNativeFields();
      // An image preview or upload cropper is not the native personalization form.
      var popup = Array.from(document.querySelectorAll(editorSelector)).some(visible);
      var inline = Array.from(document.querySelectorAll(fieldSelector)).some(function (field) {
        return visible(field) && !field.closest(popupSelector);
      });
      if (popup || inline) { finish(); return; }
      if (clicked) return;
      var button = Array.from(document.querySelectorAll('.pplr-c-button')).find(function (candidate) {
        return visible(candidate) && !candidate.disabled && candidate.getAttribute('aria-disabled') !== 'true';
      });
      if (button) {
        clicked = true;
        state = 'opening';
        button.click();
        // Keep the loading guard until opening is observed, rather than assuming click succeeded.
        check();
      }
    }
    function scheduleCheck() {
      if (scheduled || completed || (state !== 'waiting' && state !== 'opening')) return;
      scheduled = true;
      window.setTimeout(function () { scheduled = false; check(); }, 0);
    }
    function fail() {
      if (completed) return;
      state = 'error';
      stopWaiting();
      status.setAttribute('role', 'alert');
      message.textContent = 'La personnalisation n’a pas pu se charger. Réessayez avant de commander.';
      retry.hidden = false;
    }
    function begin() {
      if (completed) return;
      clicked = false;
      state = 'waiting';
      retry.hidden = true;
      status.setAttribute('role', 'status');
      message.textContent = 'Votre espace de personnalisation se prépare…';
      waitingObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled'] });
      timer = window.setTimeout(fail, 20000);
      poll = window.setInterval(check, 300);
      check();
    }
    var waitingObserver = new MutationObserver(scheduleCheck);
    var labelsObserver = new MutationObserver(function () { labelNativeFields(); });
    // Remain label-only after opening: no future variant, field value, order state or modal is overridden.
    labelsObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    root.addEventListener('submit', guardSubmit, true);
    root.addEventListener('click', guardClick, true);
    retry.addEventListener('click', begin);
    begin();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
